    /**
     * Select2 setUP
     */
    window.select2Setup = function (){

        let elements = $('select.select2:visible').not('.select2-init').addClass('select2-init');

        elements.each(function(){

            let select = $(this);

            let dropdown_parent = $('body');
            if( select.closest('.modal-page-content').length )
                dropdown_parent = select.closest('.modal-page-content')

            if( select.is('[data-search-model]') ){

                if( !select.attr('data-search-template-result') )
                    showError('You should specify attr data-search-template-result on html elem.');

                let templateForResult = '<div>' + select.attr('data-search-template-result') + '</div>';
                let templateResultItems = templateForResult.match(/(item\.[\w.]+)/gm);

                let templateForSelected = select.attr('data-search-template-selected') ?? select.attr('data-search-template-result');
                let templateSelectedItems = templateForSelected.match(/(item\.[\w.]+)/gm);

                let columns = select.is('[data-search-columns]') ? select.attr('data-search-columns').split(' ') : null; //По каким полям будет идти поиск, по умолчанию по всем полям

                let field_to_option_value = select.is('[data-search-field]') ? select.attr('data-search-field') : 'id'; //Какое поле сущности выводить в option value

                select.select2({
                    language: window.select2_ru,
                    dropdownParent: dropdown_parent,
                    ajax: {
                        url: '/select2/search',
                        dataType: 'json',
                        cache: true,
                        data: function(params){
                            return {
                                search: params.term || '',
                                page: params.page || 1,
                                columns: columns,
                                model: select.attr('data-search-model'),
                                with_relations: select.attr('data-search-with-relations') //Через запятую связанные модели, которые подгрузить
                            };
                        },
                        processResults: function(data){

                            let items = data.results.data;

                            if( field_to_option_value !== 'id' ){

                                items = $.map(items, function (item) {
                                    item.id = item[field_to_option_value];
                                    return item;
                                });

                            }


                            return {
                                results: items,
                                pagination: {
                                    more: data.results.next_page_url
                                }
                            }
                        },
                        error: function (error,i,code) {

                            if( code !== 'abort' )
                                showError(error,code);

                        }
                    },
                    templateResult: select2OutputFormat(templateForResult, templateResultItems),
                    templateSelection: select2OutputFormat(templateForSelected, templateSelectedItems), //Чтобы нормально работал шаблон для выбранных элементов, изначально не должно быть прописано <option> в <select> без selected
                });

            }else{

                select.select2({
                    language: window.select2_ru,
                    minimumResultsForSearch: 10,
                    dropdownParent: dropdown_parent
                });

            }


        });

        elements.on("select2:select", function (e){

            let div = $(this).closest('div.input');

            if( !div.length )
                div = $('.input.focus:first');

            if( e.params.data.text || $(this).data('ajax-url') ){

                div.removeClass('no-active');

            }else{

                div.addClass('no-active').removeClass('focus');

            }

        });

        elements.on('select2:open', (e) => {

            $(".select2-search__field" ).attr( 'autocomplete', 'new-password' );

            setTimeout(function (){

                if( $('.select2-container--open .select2-search__field').length )
                    $('.select2-container--open .select2-search__field')[0].focus();

            }, 200);

        });


        $(".select2-search__field" ).attr( 'autocomplete', 'new-password' );

    };




    /**
     * Формат вывода данных в select2 ajax search
     */
    function select2OutputFormat( template, templateItems ){

        return function(item){
            if( item.loading )
                return item.text;

            if( item.selected )
                return $.parseHTML(item.text);

            if( item.title === 'preloaded' )
                return item.text;

            if( !template.length )
                return 'Missing result template';

            let result = template;
            let fn = result.matchAll(/_(?<functionName>\w+)\s*\((?<functionArguments>(?:[^()]+)*)?\s*\)/g); //Есть ли функция в шаблоне (прописывается сперва нижнее подчеркивание, например: _langText(item.name)

            let val = item;
            let token_parts;
            let to_replace;

            //Если в шаблоне есть какие-то функции, например: _langText(item.name)
            if( fn ){

                for( let match of fn ) {

                    let fn_name = match.groups.functionName;
                    let fn_args = match.groups.functionArguments;

                    val = item;

                    token_parts = fn_args.split('.');
                    token_parts.forEach(function(token_part, index){

                        if( token_part !== 'item' && index !== 0 )
                            val = val[token_part];

                    });

                    to_replace = '_' + fn_name + '(' + fn_args + ')';
                    val = window[fn_name](val);

                    result = result.replace(to_replace, val);

                }

            }

            if( templateItems ) {

                templateItems.forEach(function (token) {

                    val = item;

                    token_parts = token.split('.');
                    token_parts.forEach(function (token_part, index) {

                        if (token_part !== 'item' && index !== 0)
                            val = val[token_part];

                    });

                    if (val === undefined)
                        val = 'ID: ' + item['id'];

                    result = result.replace(token, val);

                });

            }

            return $.parseHTML(result);

        }

    }
